import { render } from "./PagamentoSortePix.vue?vue&type=template&id=67d23fb2"
import script from "./PagamentoSortePix.vue?vue&type=script&lang=js"
export * from "./PagamentoSortePix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__